import { getExamsByType } from "@/utils/apis/emr-service";
import { BucketFolder } from "@/utils/enums/BucketFolder";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useFilesStore } from "@/utils/stores/useFilesStore";
import { useCallback, useState } from "react";

export const useUserFiles = () => {
    const { auth } = useAuthStore();
    const { updateFilesData } = useFilesStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchUserFiles = useCallback(async () => {
        const { userId, idToken } = auth;
        if (!userId || !idToken) return;

        try {
            setIsLoading(true);
            const userFiles = await getExamsByType(userId, idToken, BucketFolder.UploadedFromUser);
            if (userFiles) {
                updateFilesData({ userFiles });
            }
        } catch (error) {
            console.error("Error fetching user files:", error);
        } finally {
            setIsLoading(false);
        }
    }, [auth, updateFilesData]);

    return {
        fetchUserFiles,
        isLoading,
    };
}